if (!customElements.get("heala-product-tabs")) {
  class HealaProductTabs extends HTMLElement {
    connectedCallback() {
      this.triggers = Array.from(this.querySelectorAll("[data-heala-tab-trigger]"));
      this.moreButtons = Array.from(this.querySelectorAll("[data-heala-tab-more]"));
      if (!this.triggers.length) return;

      this.onTriggerClick = this.onTriggerClick.bind(this);
      this.onMoreClick = this.onMoreClick.bind(this);
      this.onResize = this.scheduleMeasure.bind(this);

      this.triggers.forEach((trigger) => {
        trigger.addEventListener("click", this.onTriggerClick);
      });
      this.moreButtons.forEach((button) => {
        button.addEventListener("click", this.onMoreClick);
      });

      window.addEventListener("resize", this.onResize);
      this.scheduleMeasure();

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.scheduleMeasure()).catch(() => {});
      }
    }

    disconnectedCallback() {
      if (this.measureRaf) cancelAnimationFrame(this.measureRaf);
      window.removeEventListener("resize", this.onResize);

      if (this.triggers) {
        this.triggers.forEach((trigger) => {
          trigger.removeEventListener("click", this.onTriggerClick);
        });
      }
      if (this.moreButtons) {
        this.moreButtons.forEach((button) => {
          button.removeEventListener("click", this.onMoreClick);
        });
      }
    }

    onTriggerClick(event) {
      const trigger = event.currentTarget;
      const isMobile = window.matchMedia("(max-width: 767px)").matches;
      const isOpen = trigger.getAttribute("aria-expanded") === "true";

      if (isMobile && isOpen) {
        this.closeAll();
        return;
      }

      this.select(trigger);
    }

    onMoreClick(event) {
      const button = event.currentTarget;
      const panel = button.closest("[data-heala-tab-panel]");
      if (!panel) return;

      const expanded = panel.classList.toggle("is-expanded");
      button.setAttribute("aria-expanded", expanded ? "true" : "false");
      button.textContent = expanded
        ? button.dataset.labelLess || "Show less"
        : button.dataset.labelMore || "Show more";

      this.scheduleMeasure();
    }

    select(activeTrigger) {
      this.triggers.forEach((trigger) => {
        const panelId = trigger.getAttribute("aria-controls");
        const panel = panelId ? document.getElementById(panelId) : null;
        const isActive = trigger === activeTrigger;

        trigger.classList.toggle("is-active", isActive);
        trigger.setAttribute("aria-expanded", isActive ? "true" : "false");
        if (panel) panel.hidden = !isActive;
      });

      this.scheduleMeasure();
    }

    closeAll() {
      this.triggers.forEach((trigger) => {
        const panelId = trigger.getAttribute("aria-controls");
        const panel = panelId ? document.getElementById(panelId) : null;

        trigger.classList.remove("is-active");
        trigger.setAttribute("aria-expanded", "false");
        if (panel) panel.hidden = true;
      });
    }

    scheduleMeasure() {
      if (this.measureRaf) cancelAnimationFrame(this.measureRaf);
      this.measureRaf = requestAnimationFrame(() => this.measurePanels());
    }

    measurePanels() {
      this.querySelectorAll("[data-heala-tab-panel]").forEach((panel) => {
        const clip = panel.querySelector("[data-heala-tab-clip]");
        const more = panel.querySelector("[data-heala-tab-more]");
        if (!clip || !more || panel.hidden) return;

        if (panel.classList.contains("is-expanded")) {
          more.hidden = false;
          more.textContent = more.dataset.labelLess || "Show less";
          more.setAttribute("aria-expanded", "true");
          return;
        }

        more.hidden = true;
        const overflows = clip.scrollHeight - clip.clientHeight > 4;
        more.hidden = !overflows;
        more.textContent = more.dataset.labelMore || "Show more";
        more.setAttribute("aria-expanded", "false");
      });
    }
  }

  customElements.define("heala-product-tabs", HealaProductTabs);
}
